import { TeamMember } from '../../types/vc';
import { SectionTitle } from './SectionTitle';

interface TeamListProps {
  members: TeamMember[];
}

function getInitials(name: string) {
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase();
}

export function TeamList({ members }: TeamListProps) {
  return (
    <div>
      <SectionTitle>Team Members</SectionTitle>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {members.map((member, index) => (
          <div key={index} className="flex items-center space-x-3">
            {member.image ? (
              <img
                src={member.image}
                alt={member.name}
                className="h-10 w-10 rounded-full object-cover"
              />
            ) : (
              <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center">
                <span className="text-sm font-medium text-indigo-600">
                  {getInitials(member.name)}
                </span>
              </div>
            )}
            <div>
              <p className="text-sm font-medium text-gray-900">{member.name}</p>
              <p className="text-xs text-gray-500">{member.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 